module.exports = __webpack_public_path__ + "media/images/icons/filled/picture-3f9ad5f71f9a78f05bbbbdf8a1d2104c.svg";